import { NOT_FOUND } from '@/common/constants';
import axiosPublic from '@/common/interceptors/axios.PublicInterceptor';

export class NotFountError extends Error {}

const getScanSelfServiceProduct = ({ queryKey: [endpoint, codeOrRef] }) =>
  new Promise((resolve, reject) => {
    axiosPublic
      .get(`/api/self-scan-service/${endpoint}`)
      .then((res) => resolve(res.data))
      .catch((error) => {
        if (error.response.status === NOT_FOUND) {
          reject(new NotFountError(codeOrRef));
        } else {
          reject(new Error());
        }
      });
  });

export default getScanSelfServiceProduct;
